import styled from 'styled-components';
import { Flex } from '@ui-library/misc';
import { Popover } from 'antd';
import { FixMe } from '@utils/types';
import Input from '@ui-library/input';

export const ButtonWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  svg {
    cursor: pointer;
  }
`;

export const ErrorPopover = styled(Popover)`
  .errorOverlay {
    background-color: rgb(235, 0, 0, 0.08);
  }
`;
export const EditableInput = styled(Input)`
  width: 100%;
  margin-right: 2px;
  text-overflow: ellipsis;
`;

export const EditColumnWrapper = styled<FixMe>(Flex)`
  .editIcon {
    opacity: 0;
  }
  &:hover {
    .editIcon {
      opacity: 1;
    }
  }
  input {
    border: unset;
    &:focus {
      border: unset;
      outline: none;
    }
  }
`;
